// extracted by mini-css-extract-plugin
export default {"icon-nav":"buttonStyles-icon-nav_YNT","cls2":"buttonStyles-cls2__a3 buttonStyles-cls1__pE","cls1":"buttonStyles-cls1__pE"};